var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require("@assets/invisible.png"),"alt":"No Data"}}),_c('span',[_vm._v(" "+_vm._s(_vm.$t('vulInfo.noData'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }